import React from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import { faEllipsis } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  DropdownMenu as ShadcnDropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

const DropdownMenu = ({ onDeleteClick, onEditClick, taskId }) => (
  <ShadcnDropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button aria-label="Task actions" className="h-6 w-6" variant="ghost">
        <FontAwesomeIcon icon={faEllipsis} />
      </Button>
    </DropdownMenuTrigger>

    <DropdownMenuContent align="end">
      <DropdownMenuItem onClick={onEditClick}>Edit</DropdownMenuItem>

      <DropdownMenuItem asChild>
        <Link to={`/tasks-frontend/${taskId}/conversation`}>View Conversation</Link>
      </DropdownMenuItem>

      <DropdownMenuSeparator />

      <DropdownMenuItem onClick={onDeleteClick} variant="destructive">
        Delete
      </DropdownMenuItem>
    </DropdownMenuContent>
  </ShadcnDropdownMenu>
);

DropdownMenu.propTypes = {
  onDeleteClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  taskId: PropTypes.string.isRequired,
};

export default DropdownMenu;
